import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {LeafPage} from './leaf.page';

import {LeafPageRoutingModule} from './leaf-routing.module';
import {HeaderModule} from '../../components/header/header.module';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {SwiperModule} from 'swiper/angular';
import {CompaniesListModule} from 'src/app/components/companies-list/companies-list.module';
import {LeafImpactScoreModule} from '../../components/leaf-impact-score/leaf-impact-score.module';
import {ActionPointListModule} from '../../components/action-point-list/action-point-list.module';
import {PanelHeaderComponent} from "../../components/panel-header/panel-header.component";

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        RouterModule.forChild([{path: '', component: LeafPage}]),
        LeafPageRoutingModule,
        HeaderModule,
        TranslatePipe,
        TranslateDirective,
        SwiperModule,
        CompaniesListModule,
        LeafImpactScoreModule,
        ActionPointListModule,
        PanelHeaderComponent
    ],
    exports: [
        LeafPage
    ],
    declarations: [
        LeafPage
    ]
})
export class LeafPageModule {
}
